export class FeatureRequest {
  _id: string;
  title: string;
  description: string;
  status: string;
  votes: [string];
  created_at: number;
}
